"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_includes_1 = tslib_1.__importDefault(require("lodash.includes"));
var v4_1 = tslib_1.__importDefault(require("uuid/v4"));
var constants = tslib_1.__importStar(require("./constants"));
var memory_storage_1 = require("./memory-storage");
var storage_client_1 = require("./storage-client");
var webstorageSupported = true;
try {
    localStorage.setItem('foo', 'bar');
    localStorage.removeItem('foo');
}
catch (error) {
    webstorageSupported = false;
}
var queue = [];
exports.storageApi = webstorageSupported
    ? localStorage
    : new memory_storage_1.MemoryStorage();
var DEBUG = exports.storageApi.getItem('identity-web:debug') === 'true';
exports.storage = new storage_client_1.StorageClient(DEBUG, exports.storageApi);
exports.hours = function (n) { return n * exports.minutes(60); };
exports.minutes = function (n) { return n * exports.seconds(60); };
exports.seconds = function (n) { return n * 1000; };
var AuthResult = /** @class */ (function () {
    function AuthResult() {
    }
    return AuthResult;
}());
exports.AuthResult = AuthResult;
function resolveKey(key, namespacePrefix) {
    if (!namespacePrefix) {
        return key;
    }
    return key.replace(constants.PREFIX, namespacePrefix);
}
exports.resolveKey = resolveKey;
function getLocation(withPath) {
    return "" + window.location.origin + (withPath || window.location.pathname);
}
function saveRedirectState(path) {
    var nonce = v4_1.default();
    var state = JSON.stringify({ nonce: nonce });
    exports.storage.setItem(constants.STATE_KEY, state);
    setNonce(nonce, getLocation(path));
    return state;
}
exports.saveRedirectState = saveRedirectState;
/**
 * pop the nonce from storage (should only ever be accessed once)
 */
function popRedirectState() {
    var state = exports.storage.getItem(constants.STATE_KEY);
    exports.storage.removeItem(constants.STATE_KEY);
    return state;
}
exports.popRedirectState = popRedirectState;
/**
 * check to see whether login was submitted from another location
 * @param state should be a stringified Object with a "nonce" field
 * ```
 * handleRedirect(auth0Response.state)
 * ```
 */
function handleRedirect(state, logoutUrl) {
    var _this = this;
    try {
        var nonce = JSON.parse(state).nonce;
        var previous_1 = exports.storage.pop(nonce);
        var current = getLocation();
        var previouslyOnLogout = typeof logoutUrl === 'string'
            && typeof previous_1 === 'string'
            && previous_1.search(logoutUrl) > -1;
        var pageHasChanged = previous_1 !== current;
        clearNonces();
        if (pageHasChanged && !previouslyOnLogout) {
            setTimeout(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, flushQueue()];
                        case 1:
                            _a.sent();
                            window.location.href = previous_1;
                            return [2 /*return*/];
                    }
                });
            }); }, 10);
        }
        // tslint:disable-next-line:no-empty
    }
    catch (__) { }
}
exports.handleRedirect = handleRedirect;
function removeToken(namespacePrefix) {
    exports.storage.removeItem(resolveKey(constants.AUTH_RESULT_KEY, namespacePrefix));
}
exports.removeToken = removeToken;
function clearSessions() {
    var audienceStr = exports.storage.getItem(constants.AUDIENCE_KEY);
    if (!audienceStr) {
        return;
    }
    for (var _i = 0, _a = JSON.parse(audienceStr); _i < _a.length; _i++) {
        var audience = _a[_i];
        removeToken(audience);
    }
    exports.storage.removeItem(constants.AUDIENCE_KEY);
    exports.storage.removeItem(constants.SSO_KEY);
    clearNonces();
}
exports.clearSessions = clearSessions;
function setSession(result, namespacePrefix, ssoKey) {
    var audienceStr = exports.storage.getItem(constants.AUDIENCE_KEY) || '[]';
    var audiences = JSON.parse(audienceStr);
    if (!lodash_includes_1.default(audiences, namespacePrefix)) {
        audiences.push(namespacePrefix);
    }
    exports.storage.setItem(constants.AUDIENCE_KEY, JSON.stringify(audiences));
    exports.storage.setItem(resolveKey(constants.AUTH_RESULT_KEY, namespacePrefix), JSON.stringify(result));
    exports.storage.setItem(constants.SSO_KEY, ssoKey);
    return getToken(namespacePrefix, ssoKey);
}
exports.setSession = setSession;
function getToken(namespacePrefix, ssoKey) {
    var result = null;
    if (exports.storage.getItem(constants.SSO_KEY) === ssoKey) {
        try {
            result = JSON.parse(exports.storage.getItem(resolveKey(constants.AUTH_RESULT_KEY, namespacePrefix)));
            // tslint:disable-next-line:no-empty
        }
        catch (_) { }
    }
    return result;
}
exports.getToken = getToken;
function calculateExpiry(expiresIn) {
    return JSON.stringify(Number(expiresIn) * 1000 - 1000 /*clock jitter*/ + new Date().getTime());
}
exports.calculateExpiry = calculateExpiry;
function isExpired(timestring) {
    var givenDate = new Date(Number(timestring));
    var currentDate = new Date();
    return currentDate.getTime() > givenDate.getTime();
}
exports.isExpired = isExpired;
function callbackHandler(resolve, reject) {
    return function (err, result) {
        if (!result) {
            return reject(new Error('Empty response'));
        }
        if (err) {
            // tslint:disable-next-line:no-console
            console.error('error', err);
            return reject(err);
        }
        else if (result) {
            return resolve(result);
        }
    };
}
exports.callbackHandler = callbackHandler;
function flushQueue() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var __1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(queue.length !== 0)) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, queue.shift()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    __1 = _a.sent();
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 0];
                case 5: return [2 /*return*/];
            }
        });
    });
}
exports.flushQueue = flushQueue;
function invokeWithPromiseCallback(method, context) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    var func = context[method];
    var task = new Promise(function (resolve, reject) {
        args.push(callbackHandler(resolve, reject));
        return func.apply(context, args);
    });
    queue.push(task);
    task.then(function () {
        queue.splice(queue.indexOf(task), 1);
    }).catch(function () {
        queue.splice(queue.indexOf(task), 1);
    });
    return task;
}
exports.invokeWithPromiseCallback = invokeWithPromiseCallback;
function setNonce(key, value) {
    var nonces = exports.storage.get(constants.NONCE_KEY) || [];
    nonces.push(key);
    exports.storage.set(constants.NONCE_KEY, nonces);
    exports.storage.set(key, value);
}
exports.setNonce = setNonce;
function clearNonces() {
    var nonces = exports.storage.get(constants.NONCE_KEY) || [];
    nonces.forEach(function (nonce) { return exports.storage.removeItem(nonce); });
    exports.storage.removeItem(constants.NONCE_KEY);
}
exports.clearNonces = clearNonces;
